import React from 'react';
import {Image} from "react-bootstrap";
export const MemoImage = React.memo(function img({ src, fallback, width, height }) {
    return <Image roundedCircle={true} onError={(t)=>t.currentTarget.src=fallback} src={src} width={width} height={height} className="spinner" />;
});
